import { filter } from 'rxjs/operators';

import { Injectable, NgZone } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { IntercomAction } from '../models/intercom.models';

@Injectable({
  providedIn: 'root',
})
export class IntercomService {
  readonly intercom: Promise<(action: IntercomAction, data: any) => void> = this.nz.runOutsideAngular(
    () => new Promise((resolve, reject) => this.intercomResolver(resolve, reject, 0)),
  );

  constructor(
    private nz: NgZone,
    private router: Router,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => this.update());
  }

  showNewMessage(message: string): void {
    this.call(IntercomAction.ShowNewMessage, message);
  }

  startTour(tour: number): void {
    this.call(IntercomAction.StartTour, tour);
  }

  update(data?: any): void {
    data = data || { last_request_at: Math.round(Date.now() / 1000) };
    // test intercom fields AD-10547
    // if (data.contactPhone) {
    //   data = { ...data };
    //   data.phone = data.contactPhone;
    //   delete data.contactPhone;
    // }

    this.call(IntercomAction.Update, data);
  }

  private intercomResolver(resolve: (intercom: any) => void, reject: () => void, i: number): void {
    if (window.Intercom) {
      resolve(window.Intercom);
    } else if (i > 60) {
      reject();
    } else {
      setTimeout(() => this.intercomResolver(resolve, reject, i + 1), 1000);
    }
  }

  private async call(action: IntercomAction, data: any): Promise<void> {
    try {
      const intercom = window.Intercom || (await this.intercom);

      intercom?.(action, data);
    } catch {}
  }
}
